// extracted by mini-css-extract-plugin
export var qc = "quality-module--qc--3IbAu";
export var header = "quality-module--header--1Pyz-";
export var p = "quality-module--p--2wQaI";
export var list = "quality-module--list--28zdL";
export var cer = "quality-module--cer--1dM0p";